import React from 'react';

export type VideoPlayerState = {
  isPlaying: boolean;
  started: boolean;
  playerRef: React.RefObject<HTMLVideoElement>;
  played: number;
  seeking: boolean;
};

export type VideoPlayerAction =
  | { type: 'PLAY'; }
  | { type: 'PAUSE'; }
  | { type: 'TOGGLE'; }
  | { type: 'SET_SEEKING'; seeking: boolean; }
  | { type: 'SEEK'; seek: number; }
  | { type: 'SET_PLAYED'; played: number; }
  | { type: 'UPDATE_PLAYED'; }
  | { type: 'ENDED'; };

export const videoPlayerReducer = (state: VideoPlayerState, action: VideoPlayerAction): VideoPlayerState => {
  switch (action.type) {
    case 'PLAY':
      return { ...state, isPlaying: true, started: true };
    case 'PAUSE':
      return { ...state, isPlaying: false };
    case 'TOGGLE':
      return { ...state, isPlaying: !state.isPlaying, started: true };
    case 'SET_SEEKING':
      return { ...state, seeking: action.seeking };
    case 'SEEK':
      if (state.playerRef.current) {
        state.playerRef.current.currentTime = action.seek * state.playerRef.current.duration;
      }
      return { ...state, seeking: false };
    case 'SET_PLAYED':
      return { ...state, played: action.played };
    case 'UPDATE_PLAYED':
      if (state.playerRef.current && !state.seeking) {
        return { ...state, played: state.playerRef.current.currentTime / state.playerRef.current.duration };
      }
      return state;
    case 'ENDED':
      return { ...state, played: 0, isPlaying: false };
    default:
      return state;
  }
};